<template>
  <div class="w-full bg-black text-white">
    <section class="px-6 md:px-20 py-10 md:mt-10 flex justify-start">
      <div class="text-left">
        <h1 class="text-4xl md:text-5xl font-bold mb-2">
          PROGRESSO
        </h1>

        <p class="text-lg md:text-xl">
          acompanhe seu progresso nos treinamentos
        </p>
      </div>
    </section>

    <!-- Container principal -->
    <section class="relative z-10 px-1">
      <div class="max-w-screen">

        <!-- banner info -->
        <div class="px-6 md:px-20 -mt-12 md:-mt-10 md:-mb-16 flex justify-center">
          <img
            src="@/assets/banners/banner_progress_info.png"
            alt="processo"
            class="w-full md:w-4/5"
          />
        </div>

        <!-- cursando -->
        <div class="px-6 md:px-20 py-7">
          <h2 class="text-xl md:text-2xl font-bold text-white mb-4 text-start tracking-wider uppercase">
            em andamento
          </h2>

          <div
            class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 uppercase"
            v-if="news?.latest?.length"
          >
            <NewsCard
              v-for="(item, index) in events?.latest"
              :key="index"
              :title="item.title"
              :image="item.banner"
              :category="item.category"
              :channelLogo="logo"
              :publishedAt="item.created_at"
              @click="seeNotice(TheNotice, item.id)"
            />
          </div>

          <div class="w-full py-3" v-else>
            Ainda não há nada aqui 
          </div>
        </div>

        <!-- concluidos -->
        <div class="px-6 md:px-20 py-7">
          <h2
            class="text-xl md:text-2xl font-bold text-white mb-4 text-start tracking-wider uppercase"
          >
            concluídos
          </h2>

          <div
            class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6"
            v-if="news?.recommended?.length"
          >
            <NewsCard
              v-for="(item, index) in news?.recommended"
              :key="index"
              :title="item.title"
              :image="item.banner"
              :category="item.category"
              :channelLogo="logo"
              :publishedAt="item.created_at"
              @click="seeNotice(TheNotice, item.id)"
            />
          </div>

          <div class="w-full py-3" v-else>Ainda não há treinamentos concluídos</div>
        </div>

        <!-- veja também - mais treinamentos -->
        <div class="px-6 md:px-20 py-7">
          <h2
            class="text-xl md:text-2xl font-bold text-white mb-4 text-start tracking-wider uppercase"
          >
            veja também
          </h2>

          <div
            class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6"
          >
            <!-- v-if="news?.hot_now?.length" -->
            <NewsCard
              v-for="(item, index) in events"
              :key="index"
              :title="item.title"
              :image="
                item.banner !== null && item.banner !== '[]' ? fileUrl + item.banner : logo"
              :description="item.description"
              :channelLogo="logo"
              :tag="item?.tag"
              @click="watchEvent(item.id)"
            />
              <!-- :publishedAt="item.created_at" -->
          </div>

          <!-- <div class="w-full py-3" v-else>Em breve</div> -->
        </div>

      </div>
    </section>
  </div>
</template>

<script setup>
import { dataShared } from "@/shared/store";
import NewsCard from "../auth/components/NewsCard.vue";
import TheNotice from "./theNotice.vue";
import { markRaw, onMounted, computed } from "vue";
import SharedService from "@/shared/services/shared";
import { showToast as toast } from "@/helpers/UseToasts";
import router from "@/router";

const logo = require('@/assets/logo/icon.png')
const fileUrl = process.env.VUE_APP_IMAGE_SERVE + 'storage/'
const events = computed(() => dataShared.getters.getEvents);

function seeNotice(value, noticeId) {
  dataShared.dispatch("setNoticeActive", noticeId);
  dataShared.dispatch("setComponentActive", markRaw(value));
}

async function watchEvent (id) {
  dataShared.dispatch('activeLoading')

  await SharedService.watchEventById(id)
    .then((res) => {
      dataShared.dispatch('setEventToPurchase', id)

      if (res.data.success == false) {
        dataShared.dispatch('desactiveLoading')
        toast('Aviso', 'Solicite acesso ao treinamento', 'info')
        return router.push(`/training/${id}/purchase`)
      }

      dataShared.dispatch('desactiveLoading')
      dataShared.dispatch('setLiveActive', id)
      // router.push(`/module/${id}`)
      router.push(`/training/${id}/purchase`)
    })
    .catch((err) => {
      console.log(err)
    })
}

async function getAllEvents () {
  dataShared.dispatch('activeLoading')
  await SharedService.getEvents()
    .then((res) => {
      dataShared.dispatch('setAllEvents', res.data)
      console.log(res.data);
    })
    .catch((err) => {
      console.log(err)
    })
}

onMounted(() => {
  dataShared.dispatch('activeLoading')
  if(events.value?.length == 0)
    Promise.all([
      getAllEvents()
    ])
  dataShared.dispatch('desactiveLoading')
});
</script>
